import { useRef } from 'react';

import type { ValueOf } from 'type-fest';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { NOTIFICATION_TYPES } from '../../constants';

import { useAutoTaggedPetition } from './useAutoTaggedPetition';
import { useDecisionMakerRecommendation } from './useDecisionMakerRecommendation';
import { useEmailDecisionMaker } from './useEmailDecisionMaker';
import { useFreePromotion } from './useFreePromotion';
import { useFreePromotionFulfillment } from './useFreePromotionFulfillment';

type DashboardNotification = { type: ValueOf<typeof NOTIFICATION_TYPES> };
type UseNotificationsData = { notifications: DashboardNotification[] };
type UseNotificationsActions = { trackNotificationView: (notification: DashboardNotification['type']) => void };
type UseNotificationsReturn = ModelHookResult<UseNotificationsData, UseNotificationsActions>;
export function useNotificationsCenter(): UseNotificationsReturn {
	const freePromotionFulfillmentNotification = useFreePromotionFulfillment();
	const freePromotionNotification = useFreePromotion();
	const decisionMakerRecommendationNotification = useDecisionMakerRecommendation();
	const autoTaggedPetitionNotification = useAutoTaggedPetition();
	const emailDecisionMakerNotification = useEmailDecisionMaker();
	const notifications = [
		freePromotionFulfillmentNotification,
		decisionMakerRecommendationNotification,
		freePromotionNotification,
		autoTaggedPetitionNotification,
		emailDecisionMakerNotification,
	].filter(Boolean);

	const track = useTracking();
	const trackedNotifications = useRef<Array<DashboardNotification['type']>>([]);
	const trackNotificationView = (notification: DashboardNotification['type']) => {
		if (trackedNotifications.current.includes(notification)) return;
		void track('petition_manage_notification_view', { notification });
		trackedNotifications.current.push(notification);
	};

	return {
		data: { notifications },
		actions: { trackNotificationView },
	};
}
